import { MatSnackBarConfig } from '@angular/material/snack-bar';

export const SNACK_BAR_DEFAULT_OPTIONS: MatSnackBarConfig = {
  verticalPosition: 'bottom',
  horizontalPosition: 'center',
  duration: 3000,
  panelClass: ['toast', 'success'],
};
